import { useEffect, useState } from "react";

const DEFAULT_QUERY = "(max-width: 1199.98px)";

/**
 * True when viewport matches compact (phone + tablet) layout.
 * Mirrors App.js / CloudOfficeResponsive 1200px shell breakpoint.
 */
export default function useCompactViewport(query = DEFAULT_QUERY) {
  const [compact, setCompact] = useState(() => {
    if (typeof window === "undefined" || !window.matchMedia) return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return undefined;
    const mq = window.matchMedia(query);
    const update = () => setCompact(mq.matches);
    update();
    if (mq.addEventListener) {
      mq.addEventListener("change", update);
      return () => mq.removeEventListener("change", update);
    }
    mq.addListener(update);
    return () => mq.removeListener(update);
  }, [query]);

  return compact;
}
